export default "__VITE_ASSET__CNRcfMXo__"